import { IBranchInspection, IBranchInspectionPersistence } from '../interfaces';

export class BranchInspectionMapper {
  public static toDomain(inspection: IBranchInspectionPersistence): IBranchInspection {
    return {
      id: inspection.id,
      branchId: inspection.branch_id,
      stateId: inspection.state_id,
      note: inspection.note ?? '',
      deadline: inspection.deadline,
      startedAt: inspection.started_at,
      completedAt: inspection.completed_at,
      createdBy: inspection.created_by,
      executedBy: inspection.executed_by,
      createdAt: inspection.created_at,
      updatedAt: inspection.updated_at,
      branch: inspection.branch,
      state: inspection.state,
      createdByUser: inspection.created_by_user,
      executedByUser: inspection.executed_by_user,
    };
  }
}
